import {inject} from '@angular/core';
import {AuthService} from "../_services/auth.service";
import {Router} from "@angular/router";
import {GlobalStore} from "../global.store";
import {filter, map, take} from "rxjs";

export const userDataFilledGuard = () => {
  const globalStore = inject(GlobalStore);
  const router = inject(Router);

  return globalStore.currentUser$.pipe(
    filter(user => !!user),
    take(1),
    map(user => {
      if (!user.name || !user.phone) return router.parseUrl('/fill-info');

      return true;
    })
  );
};
